import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faExpand } from '@fortawesome/free-solid-svg-icons';
import '../../styles/boat/BoatCard.css';
import BoatGalleryModal from './BoatGalleryModal';
import BoatEmptyImagePlaceholder from '../BoatPage/BoatEmptyImagePlaceholder';

const THUMB_WINDOW_SIZE = 3;

const BoatImageGallery = ({ images = [], alt, onMainImageClick }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [thumbStartIndex, setThumbStartIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const total = images.length;

  React.useEffect(() => {
    if (thumbStartIndex > total - THUMB_WINDOW_SIZE) {
      setThumbStartIndex(Math.max(0, total - THUMB_WINDOW_SIZE));
    }
  }, [total, thumbStartIndex]);

  const adjustThumbWindow = (newIndex) => {
    if (newIndex < thumbStartIndex) {
      setThumbStartIndex(newIndex);
    } else if (newIndex >= thumbStartIndex + THUMB_WINDOW_SIZE) {
      setThumbStartIndex(newIndex - THUMB_WINDOW_SIZE + 1);
    }
  };

  const prevImage = (e) => {
    e.stopPropagation();
    const newIndex = (currentIndex === 0 ? total - 1 : currentIndex - 1);
    setCurrentIndex(newIndex);
    adjustThumbWindow(newIndex);
  };

  const nextImage = (e) => {
    e.stopPropagation();
    const newIndex = (currentIndex === total - 1 ? 0 : currentIndex + 1);
    setCurrentIndex(newIndex);
    adjustThumbWindow(newIndex);
  };

  const handleThumbnailClick = (idx, e) => {
    e.stopPropagation();
    setCurrentIndex(idx);
    adjustThumbWindow(idx);
  };

  let visibleThumbs = images.slice(thumbStartIndex, thumbStartIndex + THUMB_WINDOW_SIZE);
  if (visibleThumbs.length < THUMB_WINDOW_SIZE) {
    visibleThumbs = [
      ...visibleThumbs,
      ...Array(THUMB_WINDOW_SIZE - visibleThumbs.length).fill(null)
    ];
  }

  return (
    <div className="boat-card__image-section">
      <div className="boat-card__main-image" onClick={total > 0 ? onMainImageClick : undefined} style={{ position: 'relative' }}>
        {total > 1 && (
          <>
            <button className="boat-card__arrow left" onClick={prevImage} aria-label="Previous image">
              <FontAwesomeIcon icon={faChevronLeft} className="boat-card__arrow-icon" />
            </button>
            <button className="boat-card__arrow right" onClick={nextImage} aria-label="Next image">
              <FontAwesomeIcon icon={faChevronRight} className="boat-card__arrow-icon" />
            </button>
          </>
        )}
        {images[currentIndex] ? (
          <img src={images[currentIndex]} alt={alt} />
        ) : (
          <BoatEmptyImagePlaceholder />
        )}
        {total > 0 && (
          <button
            className="boat-card__expand"
            aria-label="Expand gallery"
            onClick={e => { e.stopPropagation(); setIsModalOpen(true); }}
          >
            <FontAwesomeIcon icon={faExpand} />
          </button>
        )}
      </div>
      <div className="boat-card__thumbnails">
        {visibleThumbs.map((img, idx) => {
          const realIdx = thumbStartIndex + idx;
          if (img) {
            return (
              <div
                key={realIdx}
                className={`boat-card__thumbnail${realIdx === currentIndex ? ' active' : ''}`}
                onClick={(e) => handleThumbnailClick(realIdx, e)}
              >
                <img src={img} alt={`${alt} thumbnail ${realIdx + 1}`} />
              </div>
            );
          } else {
            return (
              <div key={`placeholder-${idx}`} className="boat-card__thumbnail boat-card__thumbnail--placeholder">
                <BoatEmptyImagePlaceholder />
              </div>
            );
          }
        })}
      </div>
      {isModalOpen && (
        <BoatGalleryModal
          images={images}
          currentIndex={currentIndex}
          onClose={() => setIsModalOpen(false)}
          onChangeIndex={idx => setCurrentIndex(idx)}
        />
      )}
    </div>
  );
};

export default BoatImageGallery; 